module.exports = {
    api_host:'https://console-api.deavil.com'
}; 